import { Component, Input } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent extends DialogContentBase {

  constructor( public dialog: DialogRef) {   super(dialog);  }

  @Input() question:string;
  @Input() htmlQuestionBody:string;


  confirm(){
        this.dialog.close({ text: 'OK' });
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }
}
